// extracted by mini-css-extract-plugin
export default {"alignTop":"alignTop---tuveK"};